import React from "react";
import { Navigate } from "react-router-dom";

import usePlanFeatures from "../hooks/usePlanFeatures";
import UpgradePlan from "../pages/Adatis/Shared/UpgradePlan";
import { PlanFeatureKey } from "../services/sessionCapabilitiesService";
import { getDefaultHomePathForRoles } from "./roleAccess";

interface PlanGuardProps {
  feature: PlanFeatureKey | string;
  children: React.ReactNode;
  /** When true, redirect home instead of showing UpgradePlan. */
  redirectOnDeny?: boolean;
}

const PlanGuard = ({
  feature,
  children,
  redirectOnDeny = false,
}: PlanGuardProps) => {
  const { can, isLoading } = usePlanFeatures();

  if (isLoading) {
    return null;
  }

  if (can(feature)) {
    return <>{children}</>;
  }

  if (redirectOnDeny) {
    return <Navigate to={getDefaultHomePathForRoles()} replace />;
  }

  return <UpgradePlan />;
};

export default PlanGuard;
